import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Table,
  Button,
  Tag,
} from "antd";
import { Spin } from "antd/lib";
import { PageHeader } from '@ant-design/pro-components';
import { ExpandAltOutlined, EditOutlined } from "@ant-design/icons";
import { AlignType } from 'rc-table/lib/interface';
import { isStateValid, onlyNumbers } from "../../../utils/utilsFunctions";
import { maskNumeroProcesso } from "../../../utils/maskFunctions";
import { maskCnpj } from "../../../utils/maskFunctions";
import { apiCand } from "../../../services/apiCand";

import { ICertificadoraConsulta } from "../Componentes/InterfaceCertificadoras";

import "../style.css";
import { errorMessage, infoMessage } from "../../../utils/messages";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../parametrosUI";
import { limparPesquisaSalva, obterPesquisa, salvarPesquisa } from "../../../utils/contextoPesquisa";

const Consultar: React.FC<any> = (props: any) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();

  const [certificadora, setCertificadora] = useState(undefined);
  const [certificadoras, setCertificadoras] = useState<ICertificadoraConsulta[]>([]);

  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);

  const [manter, setManter] = useState(2); // ESTADOS PARA PASSAR PARA A TELA SEGUINTE - 2 : Detalhar / 3 : Alterar;

  const [estadoPag, setEstadoPag] = useState({
    resultado: [] as any[],
    fluxoPagina: 0,
    query: "",
    valores: {
      linhaPorPagina: DEFAULT_PAGE_SIZE,
      cnpj: "",
      pagina: 1,
      razaoSocial: "",
      nuProcesso: "",
    },
  });


  useEffect(() => {
    window.scrollTo(0, 0);

    let estado = obterPesquisa('certificadoras');
    if (isStateValid(state)) {
      estado = state;
      setEstadoPag(state);
      setLoading(true);
      //getCertificadora(state.query);
      setLoading(false);
    } else if (estado){
      setCertificadoras(estado.resultado);
      setTotalElements(estado.resultado.length);
    }

    if (estado){
      form.setFieldsValue({
        "cnpj": maskCnpj(estado.valores.cnpj),
        "razaoSocial": estado.valores.razaoSocial,
        "nuProcesso": estado.valores.nuProcesso,
        "linhaPorPagina": estado.valores.linhaPorPagina,
        "pagina": estado.valores.pagina,
      });
    } else {
      form.setFieldsValue({
        "cnpj": "",
        "razaoSocial": "",
        "nuProcesso": "",
        "linhaPorPagina": DEFAULT_PAGE_SIZE,
        "pagina": 0,
      });
    }

  }, []);

  useEffect(() => {
    if (certificadora) pushToManter(certificadora, manter);
  }, [certificadora]);

  function pushToManter(cert: any, manter: number) {
    let tpSelecao = {
      manter: manter,
      data: cert
    }
    navigate("/certificadoras/manter", { state: tpSelecao });
  }

  function gerarColunas() {
    let cols: any[] = [];

    cols.push({
      key: "cnpj",
      width: 150,
      title: "CNPJ",
      dataIndex: "",
      render: (cert: ICertificadoraConsulta) => (
        <Input
          value={maskCnpj(cert.cnpj)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      key: "razaoSocial",
      width: 400,
      title: "Razão Social",
      dataIndex: "razaoSocial",
    });

    cols.push({
      key: "processo",
      width: 150,
      title: "Processo",
      dataIndex: "",
      render: (cert: ICertificadoraConsulta) => (
        <Input
          value={maskNumeroProcesso(cert.nuProcesso)}
          size={"small"}
          style={{ padding: 0 }}
          variant="borderless"
        />
      ),
    });

    cols.push({
      key: "situacao",
      width: 80,
      title: "Situação",
      dataIndex: "",
      render: (cert: ICertificadoraConsulta) => (
        <>
          <Tag color={cert.dtCancelamento && cert.dtCancelamento !== "" ? "volcano" : "geekblue"} key={cert.idCertificadora}>
            {cert.dtCancelamento && cert.dtCancelamento !== "" ? "INATIVO" : "ATIVO"}
          </Tag>
        </>
      ),
    });

    cols.push({
      key: "opcoes",
      width: 80,
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (cert: ICertificadoraConsulta) => (
        <>
          <ExpandAltOutlined style={{ color: "blue" }}
            // shape="round"
            id='detalhar'
            onClick={() => {
              setManter(2);
              getCertificadoraPorId(cert.idCertificadora);
            }}
          />

          {false && ( //As condições são mais complexas
            <EditOutlined style={{ color: "blue", display: cert.dtCancelamento && cert.dtCancelamento !== "" ? 'none' : 'inline' }}
              // shape="round"
              id='alterar'
              onClick={() => {
                setManter(3);
                getCertificadoraPorId(cert.idCertificadora);
              }}
            />
          )}
        </>

      ),
    });

    return cols;
  }

  const columns = gerarColunas();

  const certificadoraNaoEncontrada = () => {
    infoMessage("O sistema não encontrou resultado para consulta realizada");
  };

  const obterParametrosDoForm = () => {
    return {
        page: form.getFieldValue("pagina") || 0,
        limit: form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE, //linhaPorPagina

        cnpj: onlyNumbers(form.getFieldValue("cnpj")) || "",
        'razao-social': form.getFieldValue("razaoSocial") || "",
        nuProcesso: onlyNumbers(form.getFieldValue("nuProcesso")) || "",
    };
  }

  const getCertificadora = async () => {
    try {
      setLoading(true);

      const params = obterParametrosDoForm();
      let lQuery = `certificadoras?${(new URLSearchParams(params)).toString()}`;

      const { data } = await apiCand.get(lQuery);
      setCertificadoras(data.content);
      setTotalElements(data.totalElements);
      salvarEstado(lQuery, data.content);

      if (data.content.length === 0) {
        certificadoraNaoEncontrada();
      }
    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };

  const getCertificadoraPorId = async (idCertificadora: number) => {
    try {
      setLoading(true);

      let lQuery = `certificadoras/${idCertificadora}/full`;
      const { data } = await apiCand.get(lQuery);
      setCertificadora(data);

    } catch (error: any) {
      errorMessage("Não foi possível realizar a consulta: " + error?.message);
    } finally {
      setLoading(false);
    }
  };


  const [pageSize, setpageSize] = useState<number>(DEFAULT_PAGE_SIZE);

  const handlePaginationChange = async (page: number, pagination?: number) => {
    if (pagination) {
      setpageSize(pagination);
    }
    form.setFieldsValue({
      pagina: page-1,
    });
    getCertificadora();
  };

  const handleShowSizeChange = async (current: any, size: any) => {
    form.setFieldsValue({
      linhaPorPagina: size,
    });
    getCertificadora();
  };

  function salvarEstado(lQuery :string, dados :any[]) {
    const forparam = {
      resultado: dados,
      fluxoPagina: 0,
      query: lQuery,
      valores: {
        linhaPorPagina: form.getFieldValue("linhaPorPagina") || DEFAULT_PAGE_SIZE,
        cnpj: onlyNumbers(form.getFieldValue("cnpj")) || "",
        pagina: form.getFieldValue("pagina") || 0,
        razaoSocial: form.getFieldValue("razaoSocial") || "",
        nuProcesso: onlyNumbers(form.getFieldValue("nuProcesso")) || "",
      },
    };
    salvarPesquisa('certificadoras', forparam);
    setEstadoPag(forparam);
  }

  function limparConsulta() {
    setCertificadoras([]);
    setCertificadora(undefined);
    setTotalElements(0);
    limparPesquisaSalva();
    form.resetFields();
  }

  const maskCnpjChange = async (isValue: any) => {
    form?.setFieldsValue({
      cnpj: maskCnpj(isValue),
    });
  };

  const maskProcessoCertificadora = (isValue: string) => {
    isValue = maskNumeroProcesso(isValue);

    form?.setFieldsValue({
      nuProcesso: isValue,
    });
  };


  return (
    <>
      <Spin spinning={loading} >
        <PageHeader
          className="site-page-header"
          title="Consultar Certificadoras"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>
          <Form layout="vertical" form={form} style={{ marginTop: "-100px" }}>
            <Form.Item name="pagina" />
            <Form.Item name="linhaPorPagina" />

            <Row>
              <Col xs={24} sm={5}>
                <Form.Item
                  label="CNPJ"
                  name="cnpj">
                  <Input
                    value={form.getFieldValue("cnpj")}
                    onChange={(e) => maskCnpjChange(e.target.value)}
                    placeholder="Digitar CNPJ"
                    maxLength={18}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={5}>
                <Form.Item label="Processo" name="nuProcesso">
                  <Input
                    value={form.getFieldValue("nuProcesso")}
                    onChange={(e) => maskProcessoCertificadora(e.target.value)}
                    placeholder="Digitar Processo"
                    maxLength={20}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item label="Razão Social" name="razaoSocial">
                  <Input placeholder="Digitar razão social"></Input>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <>
                <Button
                  style={{ marginRight: "5px" }}
                  id="consultar"
                  type="primary"
                  value="default"
                  shape="round"
                  onClick={() => getCertificadora()}
                >
                  Consultar
                </Button>
                <Button
                  id="limpar"
                  value="default"
                  shape="round"
                  onClick={() => limparConsulta()}
                >
                  Limpar
                </Button>
              </>
            </Row>
          </Form>
        </Card>

        <Card title={"Resultado da consulta - " + totalElements + " encontrados"}
          style={{ display: totalElements === 0 ? 'none' : 'inline' }}
        >
          <Table
            // className="overflowConsulta"
            dataSource={certificadoras}
            size={"small"}
            columns={columns}
            rowKey="idCertificadora"
            loading={loading}
            pagination={{
              // disabled: loading,
              // current: form.getFieldValue("pagina"),
              defaultPageSize: DEFAULT_PAGE_SIZE,
              pageSize: pageSize,
              total: totalElements,
              showSizeChanger: true,
              onShowSizeChange: handleShowSizeChange,
              onChange: handlePaginationChange,
              pageSizeOptions: PAGE_SIZE_OPTIONS,
              locale: { items_per_page: "Linhas por página" },
            }}
          />
        </Card>
      </Spin>
    </>
  );
};

export default Consultar;
